import pick from 'lodash/pick'
import { useMemo } from 'react'

import { LIVE_PREVIEW_DEBOUNCE_TIME } from '@features/invoices/constants/livePreviewDebounceTime'

import { useDebouncedValue } from '../../../../../../../../../hooks'
import { InvoiceSettingsForm } from '../../../types/invoiceSettingsForm'

export const useDebouncedInvoiceSettingsFormValues = (
  formValues: InvoiceSettingsForm,
  formFieldNamesToDebounce: (keyof InvoiceSettingsForm)[],
): InvoiceSettingsForm => {
  const formValuesToDebounce = useMemo(() => {
    return pick(formValues, formFieldNamesToDebounce)
  }, [formValues, formFieldNamesToDebounce])

  const debouncedFormValues = useDebouncedValue<Partial<InvoiceSettingsForm>>(
    formValuesToDebounce,
    LIVE_PREVIEW_DEBOUNCE_TIME,
  )

  return useMemo(
    () => ({
      ...formValues,
      ...debouncedFormValues,
    }),
    [formValues, debouncedFormValues],
  )
}
